<!--
 * @Author: wjc
 * @Date: 2023-11-09 16:03:25
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2024-09-11 15:32:07
 * @Description: 
-->
<!--
 * @Author: wjc
 * @Date: 2023-11-09 15:32:19
 * @LastEditors: wjc
 * @LastEditTime: 2023-11-09 16:19:22
 * @Description: 
-->
<template>
  <MContainer
    :title="currentMenu.name"
    desc=""
    bg="/images/about-bg.png"
    :row-props="{
      span,
      gutter: $screen.higherThan('xs') ? 20 : null,
    }"
  >
    <div class="content">
      <div v-if="data.name" class="text-color-1 font-s-2.2rem font-600 mb-16px">
        {{ data.name }}
      </div>
      <div
        class="min-h-400px quill-content ql-editor w-e-text-container"
        v-html="data.content"
      ></div>
      <el-empty v-if="!data.content && !loading" description="暂无相关内容" />
    </div>
  </MContainer>
</template>

<script setup lang="ts">
  import { getAboutOtherOpen } from '~/api/activity/info'

  type Data = {
    name: string
    content: string
  }

  defineOptions({
    name: 'AboutType',
  })

  const route = useRoute()
  const $screen = useScreen()
  const span = computed(() => $screen.span.value)
  const data = ref<Data>({})
  const loading = ref(true)
  const id = computed(() => route.params.id)
  const { currentMenu } = useMenuList(id.value)

  useHead({
    title: currentMenu.name,
  })

  getAboutOtherOpen(id.value)
    .then((res) => {
      if (res) {
        data.value = res.data
      }
    })
    .finally(() => {
      loading.value = false
    })
</script>

<style scoped lang="scss">
  .content {
    @apply p-32px rounded-8px bg-white h-full;
    box-shadow: 0px 15px 40px 5px rgba(77, 63, 63, 0.08);
    @screen lt-xs {
      @apply mt-48px;
    }
  }
</style>
